export default __webpack_public_path__ + "static/media/hills.68c96ffa.png";